import React from 'react';
import { Link } from 'react-router-dom';

const ProduccionConcesionariaIndex = () => {
  return (
    <div className="p-6 max-w-4xl">
      <h1 className="text-2xl font-semibold text-gray-800">Producción concesionaria</h1>
      <p className="mt-2 text-gray-600">
        Automatización de planta concesionaria: <strong>configuración</strong> operativa, <strong>planeamiento</strong>{' '}
        (cíclicos) y <strong>operaciones</strong> (salidas y despacho). Las recetas están en el módulo{' '}
        <Link to="/produccion" className="text-teal-600 hover:underline">
          Producción
        </Link>
        .
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 max-w-5xl">
        <Link
          to="/produccion-concesionaria/configuraciones"
          className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <span className="text-lg">⚙️</span>
          <h2 className="mt-2 font-semibold text-gray-900">Configuración</h2>
          <p className="mt-1 text-sm text-gray-500">Almacenes PT, tiempos, tipos de plato y áreas de despacho.</p>
        </Link>
        <Link
          to="/produccion-concesionaria/configuraciones/tiempos"
          className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <span className="text-lg">🕐</span>
          <h2 className="mt-2 font-semibold text-gray-900">Tiempos</h2>
          <p className="mt-1 text-sm text-gray-500">Desayuno, almuerzo y cena (activo / inactivo).</p>
        </Link>
        <Link
          to="/produccion-concesionaria/configuraciones/tipo-plato"
          className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <span className="text-lg">🍽️</span>
          <h2 className="mt-2 font-semibold text-gray-900">Tipo de plato</h2>
          <p className="mt-1 text-sm text-gray-500">Bebida, segundo, guarnición, refresco, postre…</p>
        </Link>
        <Link
          to="/produccion-concesionaria/planeamiento/plantillas-ciclicos"
          className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <span className="text-lg">📅</span>
          <h2 className="mt-2 font-semibold text-gray-900">Plantillas cíclicos</h2>
          <p className="mt-1 text-sm text-gray-500">Definir plantillas: tiempos, tipos de plato y días por semana.</p>
        </Link>
        <Link
          to="/produccion-concesionaria/planeamiento/ciclicos"
          className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <span className="text-lg">🔁</span>
          <h2 className="mt-2 font-semibold text-gray-900">Cíclicos</h2>
          <p className="mt-1 text-sm text-gray-500">
            Ciclos por semana con fechas; detalle con plantilla, días, tiempos y platos.
          </p>
        </Link>
      </div>
    </div>
  );
};

export default ProduccionConcesionariaIndex;
